module.exports = __webpack_public_path__ + "static/media/hit.ef835319.wav";


//////////////////
// WEBPACK FOOTER
// ./src/game/assets/sounds/hit.wav
// module id = 62
// module chunks = 0